// File: src/pages/AdminLogin.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequestHandler } from "../../apiConfig/service";
import { toast } from "react-toastify";
import { useCart } from "../../context/cartContext";
// import 'bootstrap/dist/css/bootstrap.min.css';

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { refreshUser } = useCart();


 const handleLogin = async (e) => {
  e.preventDefault();

  const res = await apiRequestHandler({
    method: "POST",
    endPoint: "adminLogin",
    data: { email, password },
  });

  if (res?.success) {
    const { user, token } = res.data;
    const expiryTime = Date.now() + 24 * 60 * 60 * 1000;

    localStorage.setItem("token", token);
    localStorage.setItem("userType", user.userType);
    localStorage.setItem("tokenExpiry", expiryTime);
    localStorage.setItem("permissions", JSON.stringify(user.permissions));
    toast.success(res.message);
    refreshUser();

    if (user.userType === "SubAdmin") {
      const allowed = user.permissions.find((perm) => perm.isAllow);
      if (allowed) {
        // Map module name to route
        const moduleToRoute = {
          "Dashboard Access": "/admin/dashboard",
          "Blog Management": "/admin/blog-list",
          "Category Management": "/admin/category-list",
          "Service Page": "/admin/list-services",
          "Contact Forms": "/admin/contact-list",
          "Transaction List": "/admin/transaction-list",
          "Add SubAdmin": "/admin/add-subadmin",
          "List SubAdmin": "/admin/list-subadmin",
          "Static Content": "/admin/list-static-content"
        };

        const routePath = moduleToRoute[allowed.moduleName] || "/admin/dashboard";
        navigate(routePath);
      } else {
        toast.error("No permission granted to access any module.");
      }
    } else {
      // Default for Admin
      navigate("/admin/dashboard");
    }
  } else {
    toast.error(res?.data?.message || "Login failed");
  }
};


  return (
    <section className="vh-100 bg-light">
      <div className="container h-100">
        <div className="row d-flex align-items-center justify-content-center h-100">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid"
              alt="Login Visual"
            />
          </div>
          <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1 shadow p-5 bg-white rounded-4">
            <h3 className="text-center mb-4 fw-bold text-primary">
              Admin Login
            </h3>
            <form onSubmit={handleLogin}>
              <div className="form-floating mb-4">
                <input
                  type="email"
                  className="form-control"
                  id="floatingEmail"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="floatingEmail">Email address</label>
              </div>

              <div className="form-floating mb-4">
                <input
                  type="password"
                  className="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <label htmlFor="floatingPassword">Password</label>
              </div>


              <div className="d-flex justify-content-between align-items-center mb-3">
                <small className="text-muted">
                  <Link to="/admin-forgot-password" className="text-primary">
                    Forgot Password?
                  </Link>
                </small>
              </div>

              <button type="submit"                                 className="btn w-100 circle  animation">
                Login
              </button>
              
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
